import type * as api from '@gitbook/api-client';
import type * as analytics from '@gitbook/app-analytics/client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';

import { HeaderChangeRequest } from './HeaderChangeRequest';
import { HeaderRevision } from './HeaderRevision';
import { HeaderSpacePrimary } from './HeaderSpacePrimary';

/**
 * Header for a space.
 */
export function HeaderSpace(props: {
    screen: NavigationScreenSpaceState;
    space: api.Space;
    changeRequest: api.ChangeRequest | null;
    analyticsContext: analytics.AnalyticsContextSpaceContent;
}) {
    const { screen, space, changeRequest, analyticsContext } = props;

    if (screen.revision) {
        return (
            <HeaderRevision
                screen={screen}
                space={space}
                changeRequest={changeRequest}
                analyticsContext={analyticsContext}
            />
        );
    }

    if (changeRequest) {
        return (
            <HeaderChangeRequest
                screen={screen}
                space={space}
                changeRequest={changeRequest}
                analyticsContext={analyticsContext}
            />
        );
    }

    return <HeaderSpacePrimary screen={screen} space={space} analyticsContext={analyticsContext} />;
}
